import React from 'react';
import withField from '../withField';
import cx from 'classnames';

import styles from './styles.css';

export const Checkbox = ({
  label,
  onChange,
  value,
  defaultValue,
  left,
  right,
  controlled,
  minusIcon,
  tooltip,
  tooltipTop,
  className,
  style = {},
}) => (
  <label className={cx(styles.root, className)} style={style}>
    {controlled ? (
      <input
        className={styles.input}
        type="checkbox"
        onChange={onChange}
        checked={value}
      />
    ) : (
      <input
        className={styles.input}
        type="checkbox"
        defaultChecked={defaultValue || value}
        onChange={onChange}
      />
    )}
    <span
      className={cx(styles.checkbox, minusIcon && styles.minus)}
      style={{
        marginLeft: left,
        marginRight: right,
      }}
    ></span>
    <span className={styles.title}>{label}</span>
    {tooltip && (
      <div
        className={cx({
          [styles.tooltip]: true,
          [styles.tooltipBottom]: !tooltipTop,
          [styles.tooltipTop]: tooltipTop,
        })}
      >
        {tooltip}
      </div>
    )}
  </label>
);

export default withField(Checkbox);
